// extracted by mini-css-extract-plugin
export default {"table":"table_oC4hu"};